// SCSS
import '../scss/bootstrap.scss';
import 'ekko-lightbox/dist/ekko-lightbox.css';
import '../scss/main.scss';

//jQuery
import 'jquery'; //Do not delete!!! Doesn't import jQuery, but used as placeholder.
import 'bootstrap';
import 'ekko-lightbox';
import Masonry from 'masonry-layout'

import './sliders';
import Menu from './menu';
import Calendar from './calendar';
import WeatherWidget from './weather';
import LivePost from './live';

/*
 * The grid breakpoints as stated in varibles.scss
 */
const swBreakpoint = {
  xxs: 0,
  xs: 375,
  sm: 540,
  md: 768,
  lg: 1024,
  xl: 1200,
};

/*
 * Checks if is touch events are enabled 
 */
let isTouch = false;
if ('ontouchstart' in window || 'ontouch' in window) {
  isTouch = true;
  document.body.classList.add('touch');
}

/*
 * Addes the class `loaded` on document load
 */
window.addEventListener('load', () => {
  document.body.classList.add('loaded');
});

/*
 * Init Mobile Menu
 */
const navEl = document.querySelector('.header-nav');
const headerSearchForm = document.querySelector('.header-search-form');
if (navEl && headerSearchForm) {
  const mainMenu = new Menu('.header-nav', '.menu-toggle', ['open-menu']);
  navEl.addEventListener('sw.menu.open', () => {
    headerSearchForm.classList.remove('open');
  })

  document.getElementById('searchModalOpen').addEventListener('click', () => {
    headerSearchForm.classList.toggle('open');
    mainMenu.closeMenu();
  })
}
/*
 * Init Calendar
 */
new Calendar();

/*
 * Init Weather Widget
 */
new WeatherWidget('.weather-widget');

/*
 * Init Live Post
 */
new LivePost();

/*
 * Header DateTime
 */
const dateElementsCollection = document.querySelectorAll('.js-date')
if (dateElementsCollection) {
  const currentDate = new Date();
  Array.from(dateElementsCollection).forEach(element => {
    element.innerHTML = currentDate.toLocaleDateString('el-GR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
    element.setAttribute('datetime', currentDate.toISOString());
  })
}

/*
 * Print Button
 */
Array.from(document.querySelectorAll('[data-print]')).forEach(
  element => element.addEventListener('click', () => window.print())
)

/*
 * Metabox Dropdown
 */
Array.from(document.querySelectorAll('[data-dropdown]')).forEach(
  element => element.addEventListener('click', () => {
    if (element.dataset.target) {
      const target = document.getElementById(element.dataset.target);
      if (target) {
        const text = element.querySelector('.sr-only');
        if (text) {
          text.textContent = text.textContent === 'Περισσότερα' ? 'Λιγότερα' : 'Περισσότερα';
        }
        target.classList.toggle('open')
      }
    }
  })
)

/**
 * heading-duotone
 */
Array.from(document.querySelectorAll('.heading-duotone')).forEach(element => {
  const wordArray = element.textContent.split(' ');
  const newSpan = document.createElement('span')
  let startIndex = 1
  if (wordArray[0].length <= 1) {
    newSpan.textContent = wordArray[0] + ' ' + wordArray[1];
    startIndex = 2;
  } else {
    newSpan.textContent = wordArray[0];
  }
  element.textContent = wordArray.reduce((text, word, index) => {
    if (index >= startIndex) {
      text += ' ' + word;
    }
    return text;
  }, '');
  element.prepend(newSpan);
})

/**
 * Dropcap
 */
const format = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
Array.from(document.querySelectorAll('.has-drop-cap')).forEach(element => {
  const words = element.innerHTML.split(' ');
  if (words[0].length && !format.test(words[0])) {
    words[0] = '<span class="dropcap" data-dropcap="' + words[0].substring(0, 1) + '"></span>' + words[0].substring(1) + '<span class="sr-only">' + words[0] + '</span>'
  }
  element.innerHTML = words.join(' ');
});

/**
 * Listing Masonry
 */
const listingsWrapper = document.querySelector('.listings-grid');
if (listingsWrapper) {
  new Masonry(listingsWrapper, {
    itemSelector: '.listing',
    gutter: 30,
    percentPosition: true
  });
}

/*
 * Animate on entry
 */
const animateOnFirstEntryElements = document.querySelectorAll('.animate-me');
const animateOnFirstEntryObserver = new IntersectionObserver(
  function (entries) {
    entries.forEach((entry) => {
      if (
        (entry.target.dataset.ratio &&
          entry.intersectionRatio >= entry.target.dataset.ratio) ||
        (!entry.target.dataset.ratio && entry.isIntersecting)
      ) {
        entry.target.classList.add('animated');
      }
    });
  },
  {
    root: null,
    rootMargin: '0px',
    threshold: [0.0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0],
  }
);

animateOnFirstEntryElements.forEach((element) => {
  animateOnFirstEntryObserver.observe(element);
});

jQuery(function ($) {
	var $window = $(window);
	var $buttonTop = $('.button-top');
  
	$buttonTop.on('click', function() {
		$('html, body').animate({
			scrollTop: 0,
		}, 400);
	});
  
	$window.on('scroll', function() {
		if ($window.scrollTop() > 400) { 
			$buttonTop.addClass('button-top-visible');
		} else {
			$buttonTop.removeClass('button-top-visible');
		}
	});

	$(document).ready(function() {
		// Right Click Actions
		function addLink() {
			var body_element = document.getElementsByTagName('body')[0];
			var selection;
			selection = window.getSelection();
			var pagelink = "<br /><br /> Πηγή : www.paratiritis-news.gr [ <a href='" + document.location.href + "'>" + document.location.href + "</a> ]";
			var copytext = selection + pagelink;
			var newdiv = document.createElement('div');
			newdiv.style.position = 'absolute';
			newdiv.style.left = '-99999px';
			body_element.appendChild(newdiv);
			newdiv.innerHTML = copytext;
			selection.selectAllChildren(newdiv);
			window.setTimeout(function() {
				body_element.removeChild(newdiv);
			}, 0);
		}
		document.oncopy = addLink;

		$("img").on("contextmenu",function(e){
			return false;
		});
		$("figure").on("contextmenu",function(e){
			return false;
		});
	});

  if ($('.monthly-clndr').length) {
    const monthlyClndr = new Calendar();
    monthlyClndr.clndr = $('.monthly-clndr').clndr(monthlyClndr.options);
  }

  /** 
   * Flipbook
  */
  if (jQuery().flipBook) {
    $("#flipbook").flipBook({
      pdfUrl: $("#flipbook").data('pdfUrl'),
      skin: 'dark',
      layout: 3,
      currentPage: {
        enabled: true,
        title: "Τρέχουσα σελίδα",
      },
      btnNext: {
        enabled: true,
        title: "Επόμενη σελίδα",
      },
      btnLast: {
        enabled: false,
        title: "Τελευταία σελίδα",
      },
      btnPrev: {
        enabled: true,
        title: "Προηγύμενη σελίδα",
      },
      btnZoomIn: {
        enabled: true,
        title: "Μέγενθυνση",
      },
      btnZoomOut: {
        enabled: true,
        title: "Σμίκρυνση",
      },
      btnRotateLeft: {
        enabled: false,
        title: "Περιστροφή αριστερά",
      },
      btnRotateRight: {
        enabled: false,
        title: "Περιστροφή δεξιά",
      },
      btnAutoplay: {
        enabled: true,
        title: "Αυτόματο ξεφύλλισμα",
      },
      btnSearch: {
        enabled: true,
        title: "Αναζήτηση",
      },
      btnSelect: {
        enabled: true,
        title: "Επιλογή κειμένου",
      },
      btnBookmark: {
        enabled: true,
        title: "Σελιδοδείκτης",
      },
      btnToc: {
        enabled: false
      },
      btnThumbs: {
        enabled: true,
        title: "Σελίδες",
      },
      btnShare: {
        enabled: true,
        title: "Κοινοποίηση",
      },
      btnPrint: {
        enabled: true,
        title: "Εκτύπωση",
      },
      btnDownloadPages: {
        enabled: true,
        title: "Λήψη Σελίδων",
      },
      btnDownloadPdf: {
        enabled: true,
        title: "Λήψη PDF",
      },
      btnSound: {
        enabled: false,
        title: "Ένταση ήχου",
      },
      btnExpand: {
        enabled: true,
        title: "Λειτουργεία πλήρους οθόνης",
      },
      btnClose: {
        enabled: true,
        title: "Κλείσιμο",
      }
    })
  }

  /*
   * Bootstrap Lightbox for WP Block Gallery
   */
  $('.wp-block-gallery').each(function (index) {
    const galleryId = 'wp-gallery-' + index;
    $(this)
      .find('a')
      .each(function () {
        let link = $(this).attr('href');
        if (
          link.endsWith('.jpg') ||
          link.endsWith('.jpeg') ||
          link.endsWith('.png')
        ) {
          this.dataset.toggle = 'lightbox';
          this.dataset.gallery = galleryId;
        }
      });
  });

  /*
   * Bootstrap Lightbox for WP Block Image
   */
  $('.wp-block-image').each(function () {
    $(this)
      .find('a')
      .each(function () {
        let link = $(this).attr('href');
        if (
          link.endsWith('.jpg') ||
          link.endsWith('.jpeg') ||
          link.endsWith('.png')
        ) {
          this.dataset.toggle = 'lightbox';
        }
      });
  });

  /*
  * Bootstrap Lightbox
  */
  $(document).on('click', '[data-toggle="lightbox"]', function (event) {
    event.preventDefault();
    $(this).ekkoLightbox({
      rightArrow:
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26"><g transform="translate(.5 .5)"><circle data-name="Ellipse 107" cx="12.5" cy="12.5" r="12.5" fill="none" stroke="#fff" stroke-miterlimit="10"/><g data-name="Group 1588"><path fill="#fff" data-name="Path 570" d="M9.948 5.116l7.644 7.644-7.644 7.645"/></g></g></svg>',
      leftArrow:
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26"><g transform="translate(.5 .5)"><circle data-name="Ellipse 108" cx="12.5" cy="12.5" r="12.5" fill="none" stroke="#fff" stroke-miterlimit="10"/><g data-name="Group 1590"><path fill="#fff" data-name="Path 571" d="M15.322 5.116l-7.644 7.645 7.644 7.644"/></g></g></svg>',
      alwaysShowClose: true,
      maxWidth: 1200,
      onShow: () => {
        document.body.classList.add('ekko-lightbox-open');
      },
      onHidden: () => {
        document.body.classList.remove('ekko-lightbox-open');
      },
      onContentLoaded: function () {
        this._$modalFooter.removeClass('hide');
        this._$modalFooter.css('display', '');
        this._$modalFooter.html('<span>' + (this._galleryIndex + 1) + ' / ' + this._$galleryItems.length + '</span>');
      }
    });
  });
});


